import { MetaUI } from "./MetaUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { useSeo } from "@/hooks/useSeo/useSeo";
import { getDefaultCategory } from "@/utils/product/getDefaultCategory";
import { FREE_DELIVERY_THRESHOLD } from "@/constants/constants.ts";

const dmsIds = ["26"];

export function Meta({
  product,
  flags,
}: Pick<StandardProps, "product" | "flags">) {
  const { title, canonicalURL } = useSeo(product);
  const { variant, isSelected } = useVariant(product);

  const availableOptions = product.fulfilmentOptions?.available ?? [];
  const findDmsId =
    availableOptions.find((option) =>
      dmsIds.includes(option?.aliases?.dmsId),
    ) || null;

  let freeDeliveryThresholdOverride;

  const parsed = parseInt(
    flags.freeDeliveryThresholdOverride.value?.toString() ?? "",
    10,
  );
  if (!isNaN(parsed)) {
    freeDeliveryThresholdOverride = parsed;
  }

  const includeDeliveryMessage = !findDmsId
    ? ` Free Delivery on orders over £${freeDeliveryThresholdOverride ?? FREE_DELIVERY_THRESHOLD}.`
    : "";
  const defaultCategory = getDefaultCategory(product);
  const metaDescription = `Buy ${product.title} from our ${defaultCategory} range at John Lewis & Partners.${includeDeliveryMessage}`;
  const useNewStructuredData = flags?.useNewStructuredData.value === true;
  return (
    <MetaUI
      metaDescription={metaDescription}
      product={product}
      title={title}
      variant={variant}
      variantIsSelected={isSelected}
      canonicalURL={canonicalURL}
      useNewStructuredData={useNewStructuredData}
    />
  );
}
